export const environment = {
  production: true,
  apiUrl: '',
  baseurl: '/fastquote/bff',
  defaultContent: './assets/i18n/it.json',
  aemContent: 'it__AEM.json',
  aemUrl:
    'https://www.allianz.it/content/dam/onemarketing/azit/allianz-it/configuratore/assets/i18n',
  defOptions: null,

  baseHref: '',
  analytics: {
    stg: 'https://assets.adobedtm.com/dd4adce84cad/369b3644dc6d/launch-e988bdc31d3c-development.min.js',
    prd: 'https://assets.adobedtm.com/dd4adce84cad/369b3644dc6d/launch-f410c6f31e75.min.js',
  },
  geoServicesUrl: 'https://geoservices.te.azi.allianzit/geoservices/rest/json',

  mapsToken: 'AIzaSyDGFXMjuMnznOebd9N9k_Pa8I75u8p9mNY', //gitleaks:allow DEMO
  //NOSONAR
  recaptcha: '6Le5Uq4ZAAAAAFcocqhauGJe9z_9V4dFj_EHxrgF', //gitleaks:allow
  mapId: '2af576e6885aa681',
  staticMapId: '5e46fbf7fdaf1a22',

  markerPath: './assets/images/geolocator/',
  paymentUrl: '/ecm/EcomCnt/Ecommerce/CallContabilita?',
};
